import { Skeleton } from "@mui/material";

export default function LoadingTextLine() {
  return <Skeleton height={30} />;
}
